import N from "./index210.mjs";
import T from "./index212.mjs";
var c = 36e5, p = 6e4, I = 2, d = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
}, U = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/, w = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/, C = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function $(t, e) {
  T(1, arguments);
  var r = e || {}, a = r.additionalDigits == null ? I : N(r.additionalDigits);
  if (a !== 2 && a !== 1 && a !== 0)
    throw new RangeError("additionalDigits must be 0, 1 or 2");
  if (!(typeof t == "string" || Object.prototype.toString.call(t) === "[object String]"))
    return /* @__PURE__ */ new Date(NaN);
  var n = h(t), i;
  if (n.date) {
    var f = O(n.date, a);
    i = S(f.restDateString, f.year);
  }
  if (isNaN(i) || !i)
    return /* @__PURE__ */ new Date(NaN);
  var o = i.getTime(), u = 0, l;
  if (n.time && (u = x(n.time), isNaN(u) || u === null))
    return /* @__PURE__ */ new Date(NaN);
  if (n.timezone) {
    if (l = M(n.timezone), isNaN(l))
      return /* @__PURE__ */ new Date(NaN);
  } else {
    var s = new Date(o + u), m = /* @__PURE__ */ new Date(0);
    return m.setFullYear(s.getUTCFullYear(), s.getUTCMonth(), s.getUTCDate()), m.setHours(s.getUTCHours(), s.getUTCMinutes(), s.getUTCSeconds(), s.getUTCMilliseconds()), m;
  }
  return new Date(o + u + l);
}
function h(t) {
  var e = {}, r = t.split(d.dateTimeDelimiter), a;
  if (r.length > 2)
    return e;
  if (/:/.test(r[0]) ? (e.date = null, a = r[0]) : (e.date = r[0], a = r[1], d.timeZoneDelimiter.test(e.date) && (e.date = t.split(d.timeZoneDelimiter)[0], a = t.substr(e.date.length, t.length))), a) {
    var n = d.timezone.exec(a);
    n ? (e.time = a.replace(n[1], ""), e.timezone = n[1]) : e.time = a;
  }
  return e;
}
function O(t, e) {
  var r = new RegExp("^(?:(\\d{4}|[+-]\\d{" + (4 + e) + "})|(\\d{2}|[+-]\\d{" + (2 + e) + "})$)"), a = t.match(r);
  if (!a)
    return {
      year: null
    };
  var n = a[1] && parseInt(a[1]), i = a[2] && parseInt(a[2]);
  return {
    year: i == null ? n : i * 100,
    restDateString: t.slice((a[1] || a[2]).length)
  };
}
function S(t, e) {
  if (e === null)
    return null;
  var r = t.match(U);
  if (!r)
    return null;
  var a = !!r[4], n = v(r[1]), i = v(r[2]) - 1, f = v(r[3]), o = v(r[4]), u = v(r[5]) - 1;
  if (a)
    return E(e, o, u) ? _(e, o, u) : /* @__PURE__ */ new Date(NaN);
  var l = /* @__PURE__ */ new Date(0);
  return !L(e, i, f) || !Y(e, n) ? /* @__PURE__ */ new Date(NaN) : (l.setUTCFullYear(e, i, Math.max(n, f)), l);
}
function v(t) {
  return t ? parseInt(t) : 1;
}
function x(t) {
  var e = t.match(w);
  if (!e)
    return null;
  var r = D(e[1]), a = D(e[2]), n = D(e[3]);
  return F(r, a, n) ? r * c + a * p + n * 1e3 : NaN;
}
function D(t) {
  return t && parseFloat(t.replace(",", ".")) || 0;
}
function M(t) {
  if (t === "Z")
    return 0;
  var e = t.match(C);
  if (!e)
    return 0;
  var r = e[1] === "+" ? -1 : 1, a = parseInt(e[2]), n = e[3] && parseInt(e[3]) || 0;
  return Z(a, n) ? r * (a * c + n * p) : NaN;
}
function _(t, e, r) {
  var a = /* @__PURE__ */ new Date(0);
  a.setUTCFullYear(t, 0, 4);
  var n = a.getUTCDay() || 7, i = (e - 1) * 7 + r + 1 - n;
  return a.setUTCDate(a.getUTCDate() + i), a;
}
var z = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function g(t) {
  return t % 400 === 0 || t % 4 === 0 && t % 100;
}
function L(t, e, r) {
  return e >= 0 && e <= 11 && r >= 1 && r <= (z[e] || (g(t) ? 29 : 28));
}
function Y(t, e) {
  return e >= 1 && e <= (g(t) ? 366 : 365);
}
function E(t, e, r) {
  return e >= 1 && e <= 53 && r >= 0 && r <= 6;
}
function F(t, e, r) {
  return t === 24 ? e === 0 && r === 0 : r >= 0 && r < 60 && e >= 0 && e < 60 && t >= 0 && t < 25;
}
function Z(t, e) {
  return e >= 0 && e <= 59;
}
export {
  $ as default
};
//# sourceMappingURL=index288.mjs.map
